import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Categories = ({ categories, selected, onSelect }) => {
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir * 320, behavior: 'smooth' });
    }
  };

  return (
    <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground">Cosa ti va oggi?</h2>
        <div className="hidden sm:flex gap-2">
          <button onClick={() => scroll(-1)} className="flex h-10 w-10 items-center justify-center rounded-full border border-border hover:bg-secondary transition-colors">
            <ChevronLeft className="h-5 w-5" />
          </button>
          <button onClick={() => scroll(1)} className="flex h-10 w-10 items-center justify-center rounded-full border border-border hover:bg-secondary transition-colors">
            <ChevronRight className="h-5 w-5" />
          </button>
        </div>
      </div>
      <div ref={scrollRef} className="flex gap-4 overflow-x-auto pb-2 ifd-scrollbar-hide">
        <button
          onClick={() => onSelect(null)}
          className={`shrink-0 flex flex-col items-center gap-2 group`}
        >
          <div className={`flex h-24 w-24 items-center justify-center rounded-2xl border-2 transition-all ${!selected ? 'border-primary bg-accent' : 'border-border bg-secondary group-hover:border-primary/50'}`}>
            <span className="font-display font-bold text-sm text-foreground">Tutti</span>
          </div>
          <span className={`text-sm font-medium ${!selected ? 'text-primary' : 'text-muted-foreground'}`}>Tutti</span>
        </button>
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => onSelect(cat.id)}
            className="shrink-0 flex flex-col items-center gap-2 group"
          >
            <div className={`h-24 w-24 rounded-2xl overflow-hidden border-2 transition-all ${selected === cat.id ? 'border-primary ring-2 ring-primary/20' : 'border-transparent group-hover:border-primary/40'}`}>
              <img src={cat.image} alt={cat.name} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300" />
            </div>
            <span className={`text-sm font-medium ${selected === cat.id ? 'text-primary' : 'text-muted-foreground'}`}>{cat.name}</span>
          </button>
        ))}
      </div>
    </section>
  );
};

export default Categories;
